import { checkExists, getUserURL } from '../../../api/commonHTTP';
import { scrollToElement } from '../../../utils/eventUtils';
import { getReqMessage } from '../../../utils/formValidation/errorMessageFunctions';
import { validateEmail } from '../../../utils/formValidation/validationFunctions';
import { regExps } from '../../../utils/formValidation/validationPatterns';
import { EMAIL } from '../../recruitment/businesses/validation/validateCreateBusinessContact';
import { validateUserTypes } from '../userValidationFunctions';
export const MIN_NAME_CHAR = 1;
export const MAX_NAME_CHAR = 100;

export const MIN_PHONE_CHAR = 11;
export const MAX_PHONE_CHAR = 15;
export const MAX_PAYROLL_CHAR = 100;
export const MAX_JOB_TITLE_CHAR = 100;

export const FIRST_NAME_MIN = `First name must be at least ${MIN_NAME_CHAR} character`;
export const FIRST_NAME_FORMAT = `First name must be in the correct format`;
export const LAST_NAME_MIN = `Last name must be at least ${MIN_NAME_CHAR} character`;

export const LAST_NAME_FORMAT = `Last name must be in the correct format`;
export const EMAIL_EXISTS = 'A user with that email address already exists';
export const NO_PRIMARY_SERVICE = 'Please select a primary service';
export const NO_PRIMARY_TEAM = 'Please select a primary team';
export const PHONE_MIN = `Phone number must be at least ${MIN_PHONE_CHAR} characters`;
export const PHONE_FORMAT = `Phone number must be in the correct format`;

export const NO_USER_TYPE_IDS = 'Please select at least one user type';

export const initialErrorState = {};

export const onValidate = (newEntry, userTypes) => {
    let newErrors = {};

    if (newEntry.firstName.length < MIN_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            firstName: { error: true, message: FIRST_NAME_MIN }
        };
    } else if (!regExps.NAME_R.test(newEntry.firstName)) {
        newErrors = {
            ...newErrors,
            firstName: { error: true, message: FIRST_NAME_FORMAT }
        };
    }

    if (newEntry.lastName.length < MIN_NAME_CHAR) {
        newErrors = {
            ...newErrors,
            lastName: { error: true, message: LAST_NAME_MIN }
        };
    } else if (!regExps.LAST_NAME_R.test(newEntry.lastName)) {
        newErrors = {
            ...newErrors,
            lastName: { error: true, message: LAST_NAME_FORMAT }
        };
    }

    if (newEntry.phoneNumber) {
        if (newEntry.phoneNumber?.trim().length < MIN_PHONE_CHAR) {
            newErrors = {
                ...newErrors,
                phoneNumber: { error: true, message: PHONE_MIN }
            };
        } else if (!regExps.PHONE_R.test(newEntry.phoneNumber)) {
            newErrors = {
                ...newErrors,
                phoneNumber: { error: true, message: PHONE_FORMAT }
            };
        }
    }

    if (!newEntry.loginEmailAddress) {
        newErrors = {
            ...newErrors,
            loginEmailAddress: { error: true, message: getReqMessage(EMAIL) }
        };
    } else newErrors = validateEmail(newEntry.loginEmailAddress, newErrors);

    if (!newEntry.communicationEmailAddress) {
        newErrors = {
            ...newErrors,
            communicationEmailAddress: { error: true, message: getReqMessage(EMAIL) }
        };
    } else newErrors = validateEmail(newEntry.communicationEmailAddress, newErrors);

    if (!newEntry.primaryServiceId) {
        newErrors = {
            ...newErrors,
            primaryServiceId: { error: true, message: NO_PRIMARY_SERVICE }
        };
    }
    if (!newEntry.primaryTeamId) {
        newErrors = {
            ...newErrors,
            primaryTeamId: { error: true, message: NO_PRIMARY_TEAM }
        };
    }

    newErrors = validateUserTypes(newEntry.userTypeIds, newErrors, userTypes);

    scrollToElement(newErrors);
    return newErrors;
};

export const checkEmailAddress = async (emailAddress) => {
    return await checkExists(getUserURL() + `rest/user/exists/email-address/${emailAddress}`).then(
        (ret) => ret
    );
};
